import React from 'react';
import Downshift from 'downshift';
import { PopOver, usePopOver } from '@xingternal/pop-over';
import { trackingURL } from '@xingternal/xing-tracking';
import { IconArrowLeft } from '@xingternal/icons';
import { useMediaListener, BREAKPOINTS } from '@xingternal/util';
// @ts-ignore
import { trackToLocalStorage, trackings } from '../tracking';
// @ts-ignore
import styles from './styles.css';
// @ts-ignore
import SearchInput from './SearchInput';
// @ts-ignore
import SearchSuggestions from './SearchSuggestions';
import { Overlay, StyledSearchBar, InnerSearchBar, BackButton, Panel, } from './SearchBar.styles';
const getSection = (currentSection = '') => ['news', 'members', 'jobs', 'events', 'groups', 'companies'].includes(currentSection)
    ? currentSection
    : 'members';
export default function SearchBar({ hasPredictiveSearch, hasActiveSearchBar, predictiveSearch, activatePredictiveSearchBar, deactivatePredictiveSearchBar, searchTerm, activeItem, triggerPredictiveSearchInput, executeSearchTracking, user, type, }) {
    const breakpoint = useMediaListener();
    const popOver = usePopOver();
    const searchLink = ({ query = '', trackingKey, }) => {
        const baseParams = `keywords=${encodeURIComponent(query)}`;
        const section = getSection(activeItem);
        const path = section === 'jobs'
            ? `/jobs/search?paging_context=global_search&${baseParams}`
            : section === 'groups'
                ? `/search/communities?${baseParams}`
                : `/search/${section}?${baseParams}`;
        return trackingURL(path, trackingKey)(trackings);
    };
    return (React.createElement(Downshift
    // override id as auto-generated is differs in server <> client when not reset
    // on each render on server side
    // https://github.com/paypal/downshift#resetidcounter
    , { 
        // override id as auto-generated is differs in server <> client when not reset
        // on each render on server side
        // https://github.com/paypal/downshift#resetidcounter
        id: "malt-xing-frame-ui-search", isOpen: hasActiveSearchBar, itemToString: (item) => (item ? item.title : ''), onSelect: (item) => {
            if (item && item.url) {
                item.trackingData &&
                    trackToLocalStorage({
                        key: 'recommendation-tracking',
                        data: item.trackingData,
                        url: item.url,
                    });
                window.location.assign(item.url);
            }
        } }, ({ getItemProps, getInputProps, highlightedIndex, getRootProps }) => (React.createElement(StyledSearchBar, { ...getRootProps({
            refKey: 'ref',
        }) }, hasActiveSearchBar && breakpoint === BREAKPOINTS.handheld ? (React.createElement(Overlay, null,
        React.createElement(Panel, null,
            React.createElement(BackButton, { onClick: deactivatePredictiveSearchBar, "data-qa": 'inc-search-back-btn' },
                React.createElement(IconArrowLeft, { width: 24, height: 24 })),
            React.createElement(InnerSearchBar, null,
                React.createElement(SearchInput, { innerRef: popOver.triggerRef, getInputProps: getInputProps, query: searchTerm, isOpen: hasActiveSearchBar, searchLink: searchLink, triggerInput: triggerPredictiveSearchInput, activate: activatePredictiveSearchBar, deactivate: deactivatePredictiveSearchBar, highlightedIndex: highlightedIndex, isOverlayOpen: true }))),
        hasPredictiveSearch && (React.createElement(SearchSuggestions, { highlightedIndex: highlightedIndex, getItemProps: getItemProps, sections: predictiveSearch.sections, userId: user.id, type: type, executeSearchTracking: executeSearchTracking, query: searchTerm, searchLink: searchLink })))) : (React.createElement(InnerSearchBar, null,
        React.createElement(SearchInput, { innerRef: popOver.triggerRef, getInputProps: getInputProps, query: searchTerm, isOpen: hasActiveSearchBar, searchLink: searchLink, triggerInput: triggerPredictiveSearchInput, activate: activatePredictiveSearchBar, deactivate: deactivatePredictiveSearchBar, highlightedIndex: highlightedIndex, isOverlayOpen: false }),
        React.createElement(PopOver, { onOutsideClick: deactivatePredictiveSearchBar, triggerRef: popOver.triggerRef, show: hasPredictiveSearch && hasActiveSearchBar, isInFlow: true, className: styles.suggestions },
            React.createElement(SearchSuggestions, { highlightedIndex: highlightedIndex, getItemProps: getItemProps, sections: predictiveSearch.sections, userId: user.id, type: type, executeSearchTracking: executeSearchTracking, query: searchTerm, searchLink: searchLink }))))))));
}
SearchBar.defaultProps = {
    activeItem: '',
    predictiveSearch: {
        trackingToken: '',
        sections: [],
    },
};
//# sourceMappingURL=SearchBar.js.map